// Reads `?from=…&to=…` URL params (the same convention as /companies/stats).
// Returns the resolved window as { fromDate, toDate } so callers can pass it
// straight to BE endpoints whose payload uses fromDate/toDate. `isExplicit`
// is true only when both params were present on the URL — drives whether the
// drill-down header surfaces a date subtitle (KPI tiles are lifetime and
// would otherwise contradict a defaulted last-30-days label).
export const readPeriodFromUrl = (
  searchParams: URLSearchParams,
): { fromDate: string; toDate: string; isExplicit: boolean } => {
  const fromDate = searchParams.get('from');
  const toDate = searchParams.get('to');
  if (fromDate && toDate) return { fromDate, toDate, isExplicit: true };
  // Floor to today's UTC midnight: stable across renders within the same UTC
  // day (so RTK Query cache keys are stable — a `new Date()` here would
  // change every call and infinite-loop the component) and always ≤ `now`
  // (BE's resolveExplicitRange rejects toDate more than 1h in the future).
  const now = new Date();
  const to = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()),
  );
  const from = new Date(to.getTime() - 30 * 24 * 60 * 60 * 1000);
  return {
    fromDate: from.toISOString(),
    toDate: to.toISOString(),
    isExplicit: false,
  };
};
